/* eslint-disable react/no-children-prop,react/display-name */
import { type ComponentType, type ReactElement, createElement } from "react"

import { DynamicHeightContainer } from "@/3514/components"
import { type TScreenBreakpoints, useScreenBreakpoints } from "@/3514/hooks"

const withDynamicHeightGuard: <TProps extends object>(
    WrapperComponent: ComponentType<TProps>
) => (props: TProps) => ReactElement =
    <TProps extends object>(WrappedComponent: ComponentType<TProps>): ((props: TProps) => ReactElement) =>
    (props: TProps): ReactElement => {
        const breakpoints: TScreenBreakpoints = useScreenBreakpoints()

        return breakpoints.xs || breakpoints.sm
            ? createElement(WrappedComponent, props)
            : createElement(DynamicHeightContainer, {
                  timeoutInMs: 250,
                  children: createElement(WrappedComponent, props)
              })
    }

export { withDynamicHeightGuard }
